export const alertConfig = {
  ACCOUNT_CREATED: {
    icon: 'success',
    textContent: 'Ficha do tutor criada com sucesso! Fique à vontade para adicionar pets ou alterar os dados, caso necessário.',
    hideBackButton: true
  },
  ACCOUNT_UPDATED: {
    icon: 'success',
    textContent: 'Os dados do tutor foram atualizados com sucesso!'
  },
  PET_CREATED: {
    icon: 'success',
    textContent: 'Prontuário do pet criado com sucesso!'
  },
  HAS_ACCOUNT: {
    icon: 'info',
    textContent: 'Identificamos que este tutor já possui um cadastro. Fique à vontade para registrar um novo pet deste tutor ou alterar os dados, caso necessário.',
    hideBackButton: true
  },
  NOT_PETS: {
    icon: 'warning',
    textContent: 'Este tutor atualmente não possui pets cadastrados. Por favor, cadastre o pet e retorne para iniciar a ficha de consulta.'
  }
}

export const LIMIT = 8

export const INITIAL_CURRENT_PAGE = 1
